import React, { useState, useEffect } from 'react';
import sanitize from 'sanitize-filename';

import {
  InteractiveResultWithActionLink,
  InteractiveResultWithActionButton
} from '../components/interactive-result-with-action';

export default function DocumentListFile(props) {
  const labels = props.labels;
  const { result, engine } = props;
  const [addedToCart, setAddedToCart] = useState(false);
  const [addToCartAnalytics, setAddToCartAnalytics] = useState(false);
  window.document.addEventListener('click', () => {
    document.querySelectorAll('.document-list__copy-btn').forEach(btn => {
      btn.classList.remove('active-copied');
    });
  });

  let docsInCart,
    indexInArray = -1;

  useEffect(() => {
    window._on('removedfromcart', getDocsInCart);

    return () => {
      window.removeEventListener('removedfromcart', getDocsInCart);
    };
  }, []);

  const getDocsInCart = () => {
    //docsInCart = Cookies.get('siplast_docs');
    docsInCart = window.localStorage.getItem('siplast_docs');
    docsInCart ? (docsInCart = JSON.parse(docsInCart)) : (docsInCart = []);

    const docInCartExists = docsInCart.find(($obj, $i) => {
      if ($obj.docName === props.docName && $obj.docType === props.docType) {
        indexInArray = $i;
        return true;
      }
    });

    setAddToCartAnalytics(!!docInCartExists);
    setAddedToCart(
      docsInCart.find(($obj, $i) => {
        if ($obj.docName === props.docName && $obj.docType === props.docType) {
          indexInArray = $i;
          return true;
        }
      })
    );
  };

  const handleAddToCartClick = e => {
    const data = {
      docName: props.docName,
      docTech: props.docTech,
      docType: props.docType,
      docUrl: props.docUrl
    };

    document.querySelectorAll('.document-list__copy-btn').forEach(btn => {
      btn.classList.remove('active-copied');
    });

    getDocsInCart();

    if (!addedToCart) {
      docsInCart.push(data);
      indexInArray = docsInCart.length - 1;
      //Cookies.set('siplast_docs', JSON.stringify(docsInCart), { expires: 36500 });
      window.localStorage.setItem('siplast_docs', JSON.stringify(docsInCart));
      document._$('#sr-notify').innerHTML = labels.documentAdded;
    } else {
      docsInCart.splice(indexInArray, 1);
      indexInArray = -1;
      //Cookies.set('siplast_docs', JSON.stringify(docsInCart), { expires: 36500 });
      window.localStorage.setItem('siplast_docs', JSON.stringify(docsInCart));
      document._$('#sr-notify').innerHTML = labels.documentRemoved;
    }

    setAddedToCart(!addedToCart);
    setAddToCartAnalytics(!addToCartAnalytics);

    window.dispatchEvent(new Event('addtocartclick'));

    // these buttons have three states, so we force focus and blur in
    // the previous sibling after click to improve user experience
    e.target.previousElementSibling.focus();
    e.target.previousElementSibling.blur();
  };

  const savePDF = (url, blobdata) => {
    document.querySelectorAll('.document-list__copy-btn').forEach(btn => {
      btn.classList.remove('active-copied');
    });

    const a = document.createElement('a');
    const pdfname = url.split('/').pop();
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new File([blobdata], pdfname, { type: 'octet/stream' });
    const linkurl = window.URL.createObjectURL(blob);
    a.href = linkurl;
    a.download = pdfname;
    a.target = '_blank';
    a.click();
    window.URL.revokeObjectURL(linkurl);
  };

  const downloadPDF = e => {
    e.preventDefault();

    document.querySelectorAll('.document-list__copy-btn').forEach(btn => {
      btn.classList.remove('active-copied');
    });
    const url = e.currentTarget.href;
    fetch(url, {
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(r => {
        return r.blob();
      })
      .then(savePDF.bind(null, url));
  };

  const handleCopyClick = e => {
    const _e = e;
    const el = _e.target;
    const data = {
      docName: props.docName,
      docTech: props.docTech,
      docType: props.docType,
      docUrl: props.docUrl
    };

    navigator.clipboard
      .writeText(data.docUrl)
      .then(() => {
        // Do not interrupt or lose focus from the page during the copy, devtools breakpoints can cause problems too.
      })
      .catch(e => {
        console.log(e);
      });

    document.querySelectorAll('.document-list__copy-btn').forEach(btn => {
      btn.classList.remove('active-copied');
      btn.blur();
    });

    const add = setTimeout(() => {
      el.classList.add('active-copied');
    }, 10);

    el.classList.add('active-copied');
    const timer = setTimeout(() => {
      clearTimeout(timer);
      el.classList.remove('active-copied');
      el.focus();
      el.blur();
    }, 3000);

    e.target.previousElementSibling.focus();
    e.target.previousElementSibling.blur();
  };

  useEffect(getDocsInCart, []);

  return (
    <>
      <li className="document-list__file">
        <p className="document-list__file-ext">{props.docType}</p>
        <div className="document-list__buttons">
          <InteractiveResultWithActionLink
            engine={engine}
            result={result}
            actionName={`download-${props.docType}`}
            className="document-list__download-btn document-list__btn"
            href={props.docUrl}
            target="_blank"
            onActivated={downloadPDF}
            download={sanitize(props.docName.replace(/\.[^/.]+$/, ''))}
          >
            <svg
              aria-label={`${labels.download} ${props.docType}: ${props.docName}`}
              className="download-icon"
              height="20"
              viewBox="0 0 120 120"
              width="14"
            >
              <use xlinkHref="#download-regular" />
            </svg>
          </InteractiveResultWithActionLink>
          <InteractiveResultWithActionButton
            engine={engine}
            result={result}
            actionName={
              addToCartAnalytics
                ? `remove-from-cart-${props.docType}`
                : `add-to-cart-${props.docType}`
            }
            ariaLabel={`${labels.addToCart}: ${props.docName}`}
            className="document-list__add-btn document-list__btn"
            dataDocName={props.docName}
            dataDocTech={props.docTech}
            dataDocType={props.docType}
            dataDocUrl={props.docUrl}
            onActivated={handleAddToCartClick}
          >
            <svg
              className={`add-icon${addedToCart ? ' display-none' : ''}`}
              height="18"
              role="presentation"
              viewBox="0 0 120 120"
              width="18"
            >
              <use xlinkHref="#plus-regular" />
            </svg>
            <svg
              className={`check-icon${!addedToCart ? ' display-none' : ''}`}
              height="18"
              role="presentation"
              viewBox="0 0 120 120"
              width="18"
            >
              <use xlinkHref="#checkmark-regular" />
            </svg>
            <svg
              className={`close-icon${!addedToCart ? ' display-none' : ''}`}
              height="18"
              role="presentation"
              viewBox="12 12 100 100"
              width="18"
            >
              <use xlinkHref="#close-regular" />
            </svg>
          </InteractiveResultWithActionButton>
          {props.docType === 'PDF' && (
            <InteractiveResultWithActionButton
              engine={engine}
              result={result}
              actionName={`copy-to-clipboard-${props.docType}`}
              ariaLabel={`${labels.copyToClipboard}: ${props.docName}`}
              className="document-list__copy-btn document-list__btn"
              dataDocName={props.docName}
              dataDocTech={props.docTech}
              dataDocType={props.docType}
              dataDocUrl={props.docUrl}
              onActivated={handleCopyClick}
              dataPdf="pdf"
            >
              <svg
                className={'copy-icon'}
                height="18"
                role="presentation"
                viewBox="0 0 120 120"
                width="18"
              >
                <use xlinkHref="#icon-copy" />
              </svg>
              <span className="document-list__copied-label">
                {labels.copyToClipboardFeedbackMessage}
              </span>
            </InteractiveResultWithActionButton>
          )}
        </div>
      </li>
    </>
  );
}
